"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tupleCV = void 0;
const constants_1 = require("../constants");
const utils_1 = require("../../utils");
function tupleCV(data) {
    for (const key in data) {
        if (!(0, utils_1.isClarityName)(key)) {
            throw new Error(`"${key}" is not a valid Clarity name`);
        }
    }
    return { type: constants_1.ClarityType.Tuple, data };
}
exports.tupleCV = tupleCV;
//# sourceMappingURL=tupleCV.js.map